import React from 'react'
import DataField from "../../utils/DataField"
import {formatAsMoney} from "../../utils/utils"
import {getCaptureType} from "../../utils/utilsTransaction"
import moment from 'moment'

function TransactionCard(props) {

    return (
        <div className="analysisCard">
            <div className={["blueText", "subtitleSize"].join(" ")}>Transação</div>
            <div className="internalCardContainer"  style={{display: "flex", flexDirection: "column"}}>
                <div className="internalCardContainer">
                    <div className={["labelText", "normalMediumSize", "bold"].join(" ")}>
                        Valor da Transação
                    </div>
                    <div className={["normalText", "moneySize", "bold"].join(" ")}>
                        {formatAsMoney(props.transaction.event_data.amount * 100, "-")}
                    </div>
                </div>
                <DataField
                    title={"Data e Hora:"}
                    label={moment(props.transaction.event_date).format("DD/MM/YYYY HH:mm:ss")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                />
                <DataField
                    title={"Método de Captura:"}
                    label={getCaptureType(props.transaction.event_data.capture_method)}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                />
            </div>
        </div>
    )
}

export default TransactionCard